module.exports = __webpack_public_path__ + "static/media/bg4.6b71dfdd.png";